import TextInput from "./TextInput";
import { todayIso } from "../../utils/schoolFeeIdentity";

/**
 * The date of birth control, ruled 2026-09-03 and carried by the widget
 * registry in docs/guidelines/configured-fields-ownership.md as the one
 * control for `CUSDOB`.
 *
 * ⛔ A NATIVE <input type="date">, never a masked free-text field: `04/03/2011`
 * is two valid dates and nothing would reject the wrong one. The native
 * control's value is already canonical `YYYY-MM-DD`, so there is no
 * transformation step between what the payer picked and what the pay request
 * carries.
 *
 * The wrapper earns its file with the two settings both forms would otherwise
 * repeat, and get wrong in different ways:
 *   - `shrink`, because MUI floats the label across the control's own
 *     `dd/mm/yyyy` placeholder without it;
 *   - `max`, so the picker cannot offer a birth date in the future.
 * `max` is a convenience and not the check -- a typed value can bypass it in
 * some browsers, which is why `isValidDateOfBirth` exists beside it.
 */
const DateOfBirthInput = ({
  id,
  label,
  value,
  onChange,
  error = false,
  helperText,
  required = false,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}) => (
  <TextInput
    fullWidth
    type="date"
    id={id}
    label={label}
    value={value}
    onChange={event => onChange(event.target.value)}
    error={error}
    helperText={helperText}
    required={required}
    variant="outlined"
    InputLabelProps={{ shrink: true }}
    inputProps={{ max: todayIso() }}
  />
);

export default DateOfBirthInput;
